import { downloadBlob, postForFile } from './batch3Api';

export { downloadBlob };

export type LedgerSource = 'xero' | 'qb' | 'sage';

export interface LedgerSlotInput {
  label: string;
  sageSheet: string;
  tx: File | null;
  tb: File | null;
}

export interface LedgerTransformSummary {
  slots: { slot: number; file: string; sheet: string; method: string }[];
}

export function transformLedgers(source: LedgerSource, slots: LedgerSlotInput[]) {
  const form = new FormData();
  slots.forEach((slot, i) => {
    if (slot.tx) form.append(`tx_${i + 1}`, slot.tx);
    if (source === 'qb' && slot.tb) form.append(`tb_${i + 1}`, slot.tb);
  });
  form.append(
    'options',
    JSON.stringify({
      source_type: source,
      slots: slots.map((s) => ({ label: s.label, sage_sheet: s.sageSheet })),
    })
  );
  return postForFile<LedgerTransformSummary>(
    '/ledger-transform/transform',
    form,
    'Combined_Transformed_Ledger.xlsx',
    'Transformation failed'
  );
}
